import React, { Component } from 'react'
import '../styles/Yakuza.css'
import Navbar from './Navbar'
import BookingContainer from './BookingContainer'
import Footer from './Footer'
import LACover from '../images/Themes/LA/la-cover.jpg'
import YakuzaCover from '../images/Themes/Yakuza/yakuza-cover.jpg'
import YakuzaCoverMobile from '../images/Themes/Yakuza/mobile-yakuza-cover.jpg'
import YakuzaVideo from '../images/Themes/Yakuza/yakuza-cover-video.jpg'
import YakuzaIcon from '../images/Themes/icon-yakuza.png'
import YakuzaPicture1 from '../images/Themes/Yakuza/yakuza-picture-1.jpg'
import YakuzaPicture2 from '../images/Themes/Yakuza/yakuza-picture-2.jpg'
import YakuzaPicture3 from '../images/Themes/Yakuza/yakuza-picture-3.jpg'
import VBNPicture1 from '../images/Themes/VBN/vbn-picture-1.jpg'
import TombeauPicture1 from '../images/Themes/Tombeau/Tombeau-picture-1.jpg'
import AbattoirPicture1 from '../images/Themes/Abattoir/abattoir-picture-1.jpg'
import MagnifierIcon from '../images/Themes/magnifier-icon.png'
import GlobeIcon from '../images/Themes/globe-icon.png'
import StarIcon from '../images/Themes/star-icon.png'
import PlayerIcon from '../images/Themes/player-icon.png'
import BrainEmoji from '../images/Themes/Yakuza/brain-emoji.png'
import { Link } from 'react-router-dom'
import ReactPlayer from 'react-player'
import { injectIntl, defineMessages } from 'react-intl'
import Helmet from 'react-helmet'

const BackgroundUrl = `url(${YakuzaCover})`;
const BackgroundUrlMobile = `url(${YakuzaCoverMobile})`;

const removeTransition = (element) => {
  element.classList.remove("site-transition--visible")
}

class Yakuza extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isTop: true,
      videoPlaying: false,
      smallVideoPlaying: false
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop) {
          this.setState({ isTop })
      }
    })

    const glitchTransition = document.getElementById("site-transition")
    window.setTimeout(() => {
      glitchTransition.classList.add("site-transition--visible")
      window.setTimeout(() => {
        removeTransition(glitchTransition)
      }, 500)
    }, 10)
  }
  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <div className="theme lost-asylum">
        <Helmet>
          <title>Mission Yakuza : l'escape game enquête à Paris</title>
          <meta name="description" content={formatMessage(messages.yakuzaMeta)} />
			<meta property="og:type" content="website"/>
			<meta property="og:url" content="https://www.one-hour.fr/yakuza/"/>
			<meta property="og:title" content="Mission Yakuza : l'escape game enquête à Paris"/>
			<meta property="og:description" content="Kinechi Shonida, célèbre parrain de la mafia japonaise est introuvable. La police scientifique a besoin de la meilleure équipe pour retrouver sa trace"/>
			<meta property="og:image" content="https://www.one-hour.fr/static/media/pressen-2.jpg"/>
			<meta property="twitter:card" content="summary_large_image"/>
			<meta property="twitter:url" content="https://www.one-hour.fr/yakuza/"/>
			<meta property="twitter:title" content="Mission Yakuza : l'escape game enquête à Paris"/>
			<meta property="twitter:description" content="Kinechi Shonida, célèbre parrain de la mafia japonaise est introuvable. La police scientifique a besoin de la meilleure équipe pour retrouver sa trace"/>
			<meta property="twitter:image" content="https://www.one-hour.fr/static/media/pressen-2.jpg"/>
			<html lang="fr" />
		  <link rel="apple-touch-icon" href="https://www.one-hour.fr/static/media/apple-touch-icon.png" />
        </Helmet>
        <div className="theme-hero">
          <Navbar
            isTop={this.state.isTop}
            handleLang={(lang) => this.props.handleLang(lang)}
            lang={this.props.lang}
            />
          <div className="theme-hero-cover theme-d-background" style={{ '--background-url': BackgroundUrl, '--background-url-mobile':BackgroundUrlMobile }}>
          {
            this.state.videoPlaying
            ?
              <ReactPlayer
                url='https://www.youtube.com/watch?v=alDcub0Ujl4'
                playing
                width="100%"
                height="100%"
                controls={false}
                onEnded={() => this.setState({ videoPlaying: false })}
                config={
                  {
                    youtube: {
                      controls: 0,
                      showInfo: 0
                    }
                  }
                } />
              : null
          }
          </div>
          {
            !this.state.videoPlaying
            ?
            <div className="theme-title">
              <div className="theme-logo" style={{ backgroundImage: `url(${YakuzaIcon})`}}></div>
              <div className="title">Mission Yakuza</div>
              <div className="play-video-button" onClick={() => this.setState({ videoPlaying: true })}>
                <span>Lancer la vidéo</span>
                <span className="play-video-icon">
                  <i className="fas fa-play"></i>
                </span>
              </div>
            </div>
            : null
          }
          {
            !this.state.videoPlaying
            ?
              <div className="theme-infobar">
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.genre)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.genreInfo)}</div>
                  <div className="theme-infobar-icon"><img src={MagnifierIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.difficulty)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.difficultyInfo)}</div>
                  <div className="theme-infobar-icon"><img src={StarIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.players)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.playersInfo)}</div>
                  <div className="theme-infobar-icon"><img src={PlayerIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.language)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.languageInfo)}</div>
                  <div className="theme-infobar-icon"><img src={GlobeIcon} alt="" /></div>
                </div>
              </div>
            : null
          }
        </div>
        <div className="theme-presentation-text-wrapper">
          <div className="theme-presentation-text">
		    <h1>{formatMessage(messages.titreh1)}</h1>
            <p>{formatMessage(messages.presentationText1)}</p>
            <p>{formatMessage(messages.presentationText2)}</p>
            <p>{formatMessage(messages.presentationText3)}</p>
            <div className="theme-presentation-disclaimer">
              <img alt="" src={BrainEmoji} />
              <span>{formatMessage(messages.disclaimer)}</span>
            </div>
          </div>
        </div>
        <div className="theme-gallery-container">
          <span className="theme-gallery-label">{formatMessage(messages.gallery)}</span>
          <div className="theme-gallery">
            <div className="theme-gallery-testimonial">
              <p className="theme-gallery-testimonial-comment">{formatMessage(messages.testimonalComment)}</p>
              <p className="theme-gallery-testimonial-author">
                <span>{formatMessage(messages.testimonalAuthor)}</span>
                <i className="fab fa-tripadvisor"></i>
              </p>
            </div>
            <div
              className="theme-gallery-image theme-gallery-video"
              style={{backgroundImage: `url(${YakuzaVideo})`}}
              >
              {
                this.state.smallVideoPlaying
                ?
                  <ReactPlayer
                    url='https://www.youtube.com/watch?v=alDcub0Ujl4'
                    playing
                    width="100%"
                    height="100%"
                    controls={false}
                    onEnded={() => this.setState({ smallVideoPlaying: false })}
                    config={
                      {
                        youtube: {
                          controls: 0,
                          showInfo: 0
                        }
                      }
                    } />
                : <div style={{ width: "100%", height: "100%", position: "relative"}}>
                    <span
                      className="theme-gallery-play-button"
                      onClick={() => this.setState({ smallVideoPlaying: true })}
                      >►</span>
                  </div>
              }
              </div>
            <div
              style={{backgroundImage: `url(${YakuzaPicture1})`}}
              className="theme-gallery-image theme-gallery-picture-1"></div>
            <div
              style={{backgroundImage: `url(${YakuzaPicture2})`}}
              className="theme-gallery-image theme-gallery-picture-2"></div>
            <div
              style={{backgroundImage: `url(${YakuzaPicture3})`}}
              className="theme-gallery-image theme-gallery-picture-3"></div>
          </div>
        </div>
        <BookingContainer
		  theme="yakuza"
          lang={this.props.lang}
          expiration={() => this.props.handleExpiration()}/>
		<div className="theme-content">
		  <p>
		  L’âge minimum pour participer à une session chez One Hour est de 14 ans.
		  </p>
		  <p>
		    <h2>Escape Game enquête de police Paris</h2>
			Mission Yakuza veut avant tout vous plonger dans une enquête policière réaliste. Vous serez amener à manipuler des objets de la police scientifique et à raisonner comme si vous deviez résoudre une véritable enquête policière ! Et vos choix seront importants, Mission Yakuza propose <strong>6 fins de jeu différentes </strong>suivant vos choix et vos succès.
		  </p>
		</div>
        <div className="theme-other-themes">
          <h3>{formatMessage(messages.discoverOurOtherThemes)}</h3>
          <div className="theme-other-themes-container">
            <Link to="/lost-asylum/">
              <div className="theme-other-themes-card">
                <div className="theme-other-themes-picture" style={{ backgroundImage: `url(${LACover})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.lostAsylum)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.laBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/very-bad-night/">
              <div className="theme-other-themes-card theme-other-themes-card--vbn">
                <div className="theme-other-themes-picture theme-other-themes-card--vbn" style={{ backgroundImage: `url(${VBNPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.VBN)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.VBNBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/abattoir/">
              <div className="theme-other-themes-card">
                <div className="theme-other-themes-picture" style={{ backgroundImage: `url(${AbattoirPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.slaughterhouse)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.slaughterhouseBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/expedition-maudite/">
              <div className="theme-other-themes-card theme-other-themes-card--tombeau">
                <div className="theme-other-themes-picture theme-other-themes-card--tombeau" style={{ backgroundImage: `url(${TombeauPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.tombeau)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.tombeauBase)}</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

const messages = defineMessages({
  playVideo: {
    id: 'themes.playVideo',
    defaultMessage: 'Lancer la vidéo'
  },
  genre: {
    id: 'themes.genre',
    defaultMessage: 'Genre'
  },
  difficulty: {
    id: 'themes.difficulty',
    defaultMessage: 'Difficulté'
  },
  players: {
    id: 'themes.players',
    defaultMessage: 'Joueurs'
  },
  language: {
    id: 'themes.language',
    defaultMessage: 'Langue'
  },
  genreInfo: {
    id: 'yakuza.genre',
    defaultMessage: 'Peur / Suspens'
  },
  difficultyInfo: {
    id: 'yakuza.difficulty',
    defaultMessage: 'Tous niveaux'
  },
  playersInfo: {
    id: 'yakuza.players',
    defaultMessage: 'de 2 à 6 joueurs'
  },
  languageInfo: {
    id: 'yakuza.language',
    defaultMessage: 'Français / Anglais'
  },
  titreh1: {
    id: 'yakuza.titreh1',
    defaultMessage: 'Escape game enquête policière Yakuza à Paris'
  },
  presentationText1: {
    id: 'yakuza.presentationText1',
    defaultMessage: '1952, un hôpital psychiatrique vient de fermer ses portes suite à un fait divers sanglant : un patient interné depuis de nombreuses années vient d’assassiner plusieurs médecins dans des circonstances encore inexpliquées. Depuis, on ne l’a jamais revu.'
  },
  presentationText2: {
    id: 'yakuza.presentationText2',
    defaultMessage: 'Le temps a passé, et les vieux murs gardent leurs secrets, les cris résonnent encore, suintent de la souffrance accumulée, et de folles rumeurs circulent...'
  },
  presentationText3: {
    id: 'yakuza.presentationText3',
    defaultMessage: 'Ceux qui ont eu la curiosité de s’approcher rapportent des faits étranges. Que se passe-t-il dans ce bâtiment abandonné ?'
  },
  disclaimer: {
    id: 'yakuza.disclaimer',
    defaultMessage: 'Attention, des éléments du jeu peuvent surprendre ou effrayer. Déconseillé aux âmes sensibles'
  },
  gallery: {
    id: 'themes.gallery',
    defaultMessage: 'Galerie'
  },
  testimonalComment: {
    id: 'yakuza.testimonalComment',
    defaultMessage: 'Un détour mortel...lement fun ! Aucun temps mort, plusieurs pièces, des énigmes retordes, très différentes et surtout bien trouvées.'
  },
  testimonalAuthor: {
    id: 'yakuza.testimonalAuthor',
    defaultMessage: '13ludwigd, Paris, France'
  },
  discoverOurOtherThemes: {
    id: 'themes.discoverOurOtherThemes',
    defaultMessage: 'Découvrez nos autres thèmes Escape game Paris :'
  },
  slaughterhouseBaseline: {
    id: 'themesContainer.slaughterhouseBaseline',
    defaultMessage: 'ça va trancher chérie'
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Yakuza"
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: "Very Bad Night"
  },
  VBNBaseline: {
    id: 'themesContainer.vbnBaseline',
    defaultMessage: "Une gueule de bois marathon"
  },
  slaughterhouseBaseline: {
    id: 'themesContainer.slaughterhouseBaseline',
    defaultMessage: 'ça va trancher chérie'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  lostAsylum: {
    id: 'themes.la',
    defaultMessage: "Lost Asylum"
  },
  laBaseline: {
    id: 'themesContainer.laBaseline',
    defaultMessage: "Echappez-vous avant de devenir fou"
  },
  yakuzaMeta: {
    id: 'themes.yakuzaMeta',
    defaultMessage: "Yakuza"
  },
  tombeau: {
    id: 'themes.tombeau',
    defaultMessage: "L'Expédition Maudite"
  },
  tombeauBaseline: {
    id: 'themesContainer.tombeauBase',
    defaultMessage: "L'aventure à la Indiana Jones"
  },
  tombeauBase: {
    id: 'themesContainer.tombeauBase',
    defaultMessage: "L'aventure à la Indiana Jones"
  },
})

export default injectIntl(Yakuza)



// WEBPACK FOOTER //
// ./src/components/Yakuza.js